import axios from 'axios'

// axios.defaults.baseURL = 'http://127.0.0.1:8000';

axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.App.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'

}

axios.interceptors.request.use(function (config) {
    if (!config.headers) {
        config.headers = {}  // Create the header object if needed.
    }
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('token')
    config.headers['Authorization'] = token ? `Bearer ${token}` : null

    return config
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
})

export default axios
